import PropTypes from "prop-types";

import Button from "../Button";
import "./EmptyState.scss";

const EmptyState = ({
  subTitle,
  description,
  ButtonLabel,
  handleCreate,
  showActionButton,
  imgSrc,
  className,
  buttonClassName,
  descriptionClassName,
  rowViewMode
}) => (
  <div
    className={`d-flex align-items-center ${
      rowViewMode
        ? "rowView row text-center text-lg-start"
        : "colView"
    } py-5 my-5 ${className}`}>
    <div className="my-5">
      <img
        src={imgSrc}
        alt="No data img"
        className={`mb-3 ${rowViewMode ? "col-lg-3 offset-lg-1" : ""}`}
      />
      <div
        className={`emptyPlaceholder-content ${rowViewMode ? "col-lg-4" : ""}`}>
        {subTitle && (
          <p className="fsize-18 fweight-600 light-text-color subTitle">
            {subTitle}
          </p>
        )}
        {description && (
          <p
            className={` fsize-16  ${
              descriptionClassName ?? "description"
            }`}>
            {description}
          </p>
        )}

        {showActionButton && (
          <Button
            label={ButtonLabel}
            type="button"
            labelClass="fsize-16 text-white font-regular"
            onClick={handleCreate}
            block={true}
            className={`border-radius-8 w-auto ${buttonClassName}`}
          />
        )}
      </div>
    </div>
  </div>
);

export default EmptyState;

EmptyState.propTypes = {
  subTitle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]),
  description: PropTypes.string,
  ButtonLabel: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]),
  handleCreate: PropTypes.func,
  showActionButton: PropTypes.bool,
  className: PropTypes.string,
  buttonClassName: PropTypes.string,
  descriptionClassName: PropTypes.string,
  rowViewMode: PropTypes.bool,
  imgSrc: PropTypes.string
};
